<template>
	<div class="file-uploader">
		<hidden-file-uploader
			:accept="accept"
			:fingerprint="fingerprint"
			:project-id="projectId"
			:question-id="message.question_id"
			@success="sendMessage"
			@failed="sendError"
		>
			<template v-slot:action="{ file, loading }">
				<div v-if="file" :class="['file-preview', { loading }]">
					<q-icon size="24px" class="file-preview-icon" name="insert_drive_file" />
					<span class="file-preview-name" v-text="file.name" />
					<q-spinner
						v-if="loading"
						class="file-preview-loader"
						color="primary"
						size="24px"
					/>
				</div>
				<q-btn
					v-else
					icon="note_add"
					label="Choose File"
					color="primary"
					class="upload-button"
				/>
			</template>
		</hidden-file-uploader>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import HiddenFileUploader from '@/components/HiddenFileUploader';

export default defineComponent({
	name: 'FileUploader',
	components: { HiddenFileUploader },
	props: {
		message: {
			type: Object
		},
		projectId: {
			type: String
		},
		fingerprint: {
			type: Object
		}
	},
	data() {
		return {
			file: null,
			loading: false
		};
	},
	computed: {
		accept() {
			return this.message.file_extensions.extensions.join(', ');
		}
	},
	methods: {
		sendMessage(file) {
			this.$emit('send-message', { attachmentId: file.id, text: file.name });
			this.destroy();
		},
		sendError(message) {
			this.$emit('send-message', { attachmentError: message, text: message });
			this.destroy();
		},
		destroy() {
			this.$el.parentNode.removeChild(this.$el);
		}
	}
});
</script>

<style scoped lang="scss">
.file-preview {
	align-items: center;
	display: flex;
	height: 40px;
	background: #e9e9e9;
	border-radius: 4px;
	padding: 0 8px;
	&-icon {
		color: rgba(0, 0, 0, 0.6);
	}
	&-name {
		color: rgba(0, 0, 0, 0.6);
		font-weight: 400;
		font-size: 14px;
		overflow: hidden;
		padding: 0 4px;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	&-loader {
		margin-left: auto;
	}
}
.file-preview.loading {
	.file-preview-icon,
	.file-preview-name {
		color: #a6a6a6;
	}
}
.upload_control {
	display: none;
}
.upload-button {
	border-radius: 8px;
	height: 40px;
	width: 100%;
}
@media screen and (min-width: 767px) {
	.file-uploader {
		display: flex;
	}
	.upload-button {
		height: 60px;
		width: 184px;
		border-radius: 0.5rem;
	}
	.file-preview {
		max-width: 522px;
		height: 60px;
		width: auto;
		border-radius: 0.5rem;
		&-name {
			font-size: 16px;
		}
	}
}
</style>
